package pl.mothdigital.neuronowi.components.layouts

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.keywords.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.components.widgets.*

@Composable
fun ImageTextFlexLayout(
    image: ImageResource,
    imageBorderRadius: CSSLengthValue = 0.cssRem,
    title: @Composable () -> Unit,
    desc: @Composable () -> Unit,
) {
    // Desktop layout
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .flexWrap(FlexWrap.WrapReverse)
            .alignItems(AlignItems.Center)
            .displayIfAtLeast(Breakpoint.MD),
    ) {
        Column(
            modifier = Modifier
                .flex(1)
                .minWidth(500.px)
                .padding(1.cssRem)
        ) {
            ImageSection(image, imageBorderRadius)
        }
        Column(
            modifier = Modifier
                .flex(1)
                .minWidth(500.px)
                .padding(1.cssRem)
        ) {
            TextSection(title, desc)
        }
    }

    // Mobile layout
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .alignItems(AlignItems.Center)
            .displayUntil(Breakpoint.MD),
    ) {
        Column(
            modifier = Modifier
                .minWidth(300.px)
                .padding(1.cssRem)
        ) {
            TextSection(title, desc)
        }
        Column(
            modifier = Modifier
                .minWidth(300.px)
                .padding(1.cssRem)
        ) {
            ImageSection(image, imageBorderRadius)
        }
    }
}

@Composable
private fun ImageSection(
    image: ImageResource,
    imageBorderRadius: CSSLengthValue
) {
    Image(
        src = image.src,
        alt = image.description,
        modifier = Modifier
            .widthIn(min = 300.px, max = 100.percent)
            .height(auto)
            .borderRadius(imageBorderRadius),
    )
}

@Composable
private fun TextSection(
    title: @Composable () -> Unit,
    desc: @Composable () -> Unit
) {
    title()
    VerticalSpacer(height = 1.cssRem)
    desc()
}
